import { useInfiniteQuery } from '@tanstack/react-query';
import { useUser } from '@shared/hooks/index.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { API } from '@src/api/index.ts';
import { ProgramsHistoryListParams } from '@src/api/programs.ts';

export const useProgramsHistoryInfiniteQuery = (
  params: Omit<ProgramsHistoryListParams, 'page' | 'module'>
) => {
  const { isAuth } = useUser();
  const { moduleId } = useModuleByCodeParam();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['programsHistory', { ...params, moduleId }],
    queryFn: async ({ pageParam = 1 }) =>
      await API.programs.getHistory({
        ...params,
        page: pageParam,
        module: moduleId,
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { next } = lastPage;
      return next ? lastPageParam + 1 : undefined;
    },
    select: (data) => {
      return {
        ...data,
        results: data?.pages.flatMap((page) => page.results),
      };
    },
    enabled: isAuth,
  });
};
